import {
    RACE_GET_ALL_REQUEST, RACE_GET_ALL_SUCCESS, RACE_GET_ALL_FAILURE,
    RACE_GET_DETAILS_REQUEST, RACE_GET_DETAILS_SUCCESS, RACE_GET_DETAILS_FAILURE,
    RACE_CREATE_REQUEST, RACE_CREATE_SUCCESS, RACE_CREATE_FAILURE,
    RACE_UPDATE_REQUEST, RACE_UPDATE_SUCCESS, RACE_UPDATE_FAILURE,
    RACE_DELETE_REQUEST, RACE_DELETE_SUCCESS, RACE_DELETE_FAILURE,
    RACE_GET_PIGEONS_REQUEST, RACE_GET_PIGEONS_SUCCESS, RACE_GET_PIGEONS_FAILURE,
    RACE_CREATE_PIGEON_REQUEST, RACE_CREATE_PIGEON_SUCCESS, RACE_CREATE_PIGEON_FAILURE,
    RACE_UPDATE_PIGEON_REQUEST, RACE_UPDATE_PIGEON_SUCCESS, RACE_UPDATE_PIGEON_FAILURE,
    RACE_DELETE_PIGEON_REQUEST, RACE_DELETE_PIGEON_SUCCESS, RACE_DELETE_PIGEON_FAILURE,
    RACE_CREATE_WATCH_REQUEST, RACE_CREATE_WATCH_SUCCESS, RACE_CREATE_WATCH_FAILURE,
    RACE_UPDATE_WATCH_REQUEST, RACE_UPDATE_WATCH_SUCCESS, RACE_UPDATE_WATCH_FAILURE,
    RACE_DELETE_WATCH_REQUEST, RACE_DELETE_WATCH_SUCCESS, RACE_DELETE_WATCH_FAILURE,
    RACE_ADD_MEMBER_GAMES_REQUEST, RACE_ADD_MEMBER_GAMES_SUCCESS, RACE_ADD_MEMBER_GAMES_FAILURE,
    RACE_REMOVE_MEMBER_GAMES_REQUEST, RACE_REMOVE_MEMBER_GAMES_SUCCESS, RACE_REMOVE_MEMBER_GAMES_FAILURE,
    RACE_ADD_DECAYS_REQUEST, RACE_ADD_DECAYS_SUCCESS, RACE_ADD_DECAYS_FAILURE,
    RACE_REMOVE_DECAYS_REQUEST, RACE_REMOVE_DECAYS_SUCCESS, RACE_REMOVE_DECAYS_FAILURE,
    RACE_GET_PRICES_REQUEST, RACE_GET_PRICES_SUCCESS, RACE_GET_PRICES_FAILURE,
    RACE_CREATE_PRICE_REQUEST, RACE_CREATE_PRICE_SUCCESS, RACE_CREATE_PRICE_FAILURE,
    RACE_UPDATE_PRICE_REQUEST, RACE_UPDATE_PRICE_SUCCESS, RACE_UPDATE_PRICE_FAILURE,
    RACE_DELETE_PRICE_REQUEST, RACE_DELETE_PRICE_SUCCESS, RACE_DELETE_PRICE_FAILURE,
    RACE_UPDATE_PRICE_ADDITIONS_REQUEST, RACE_UPDATE_PRICE_ADDITIONS_SUCCESS, RACE_UPDATE_PRICE_ADDITIONS_FAILURE,
    RACE_RESET_PRICES_REQUEST, RACE_RESET_PRICES_SUCCESS, RACE_RESET_PRICES_FAILURE,
    RACE_CALC_PRICES_REQUEST, RACE_CALC_PRICES_SUCCESS, RACE_CALC_PRICES_FAILURE,
    RACE_CALC_REQUEST, RACE_CALC_SUCCESS, RACE_CALC_FAILURE,
    RACE_GET_BASICS_REQUEST, RACE_GET_BASICS_SUCCESS, RACE_GET_BASICS_FAILURE,
    RACE_START_DEVICE_IMPORT_REQUEST, RACE_START_DEVICE_IMPORT_SUCCESS, RACE_START_DEVICE_IMPORT_FAILURE,
    RACE_UPDATE_DEVICE_IMPORT_REQUEST, RACE_UPDATE_DEVICE_IMPORT_SUCCESS, RACE_UPDATE_DEVICE_IMPORT_FAILURE,
    RACE_CHECK_DEVICE_IMPORT_REQUEST, RACE_CHECK_DEVICE_IMPORT_SUCCESS, RACE_CHECK_DEVICE_IMPORT_FAILURE,
    RACE_SEND_FROM_CLUB_REQUEST, RACE_SEND_FROM_CLUB_SUCCESS, RACE_SEND_FROM_CLUB_FAILURE,
    RACE_GET_FROM_MEMBER_REQUEST, RACE_GET_FROM_MEMBER_SUCCESS, RACE_GET_FROM_MEMBER_FAILURE,
} from '../constants/actionconstants';

import React from 'react';
import client from '../utils/ajax/client';
import * as GlobalErrorActions from '../actions/globalerror';
import { isDefined } from "../../../common/src/util/lib";
import {NotificationManager} from "react-notifications";
import {alert} from "../utils/alertDialog";

export function getRaces(onSuccess = null) {
    return (dispatch) => {
        dispatch(getRacesRequest());
        client({
            method: 'GET',
            path: '/api/races/all'
        }).then(response => {
            dispatch(getRacesSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af kapflyvninger fra databasen", response));
            dispatch(getRacesFailure(response));
        });
    }
}

function getRacesRequest() {
    return {
        type : RACE_GET_ALL_REQUEST
    }
}

function getRacesSuccess(data) {
    return {
        type : RACE_GET_ALL_SUCCESS,
        payload : data
    }
}

function getRacesFailure(error) {
    return {
        type : RACE_GET_ALL_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getRace(raceNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(getRaceRequest());
        client({
            method: 'GET',
            path: '/api/races/race/'+raceNo.toString()
        }).then(response => {
            dispatch(getRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af kapflyvning fra databasen", response));
            dispatch(getRaceFailure(response));
        });
    }
}

function getRaceRequest() {
    return {
        type : RACE_GET_DETAILS_REQUEST
    }
}

function getRaceSuccess(data) {
    return {
        type : RACE_GET_DETAILS_SUCCESS,
        payload : data
    }
}

function getRaceFailure(error) {
    return {
        type : RACE_GET_DETAILS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createRace(entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createRaceRequest());
        client({
            method: 'POST',
            path: '/api/races/race',
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.race.Nr);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af kapflyvning", response));
            dispatch(createRaceFailure(response));
        });
    }
}

function createRaceRequest() {
    return {
        type : RACE_CREATE_REQUEST
    }
}

function createRaceSuccess(entity) {
    return {
        type : RACE_CREATE_SUCCESS,
        payload : entity
    }
}

function createRaceFailure(error) {
    return {
        type : RACE_CREATE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updateRace(raceNo, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateRaceRequest());
        client({
            method: 'PUT',
            path: '/api/races/race/' + raceNo.toString(),
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess(raceNo);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af kapflyvning", response));
            dispatch(updateRaceFailure(response));
        });
    }
}

function updateRaceRequest() {
    return {
        type : RACE_UPDATE_REQUEST
    }
}

function updateRaceSuccess(entity) {
    return {
        type : RACE_UPDATE_SUCCESS,
        payload : entity
    }
}

function updateRaceFailure(error) {
    return {
        type : RACE_UPDATE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deleteRace(raceNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteRaceRequest());
        client({
            method: 'DELETE',
            path: '/api/races/race/' + raceNo,
        }).then(response => {
            dispatch(deleteRaceSuccess(raceNo));
            if (onSuccess !== null) onSuccess(raceNo);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af kapflyvning", response));
            dispatch(deleteRaceFailure(response));
        });
    }
}

function deleteRaceRequest() {
    return {
        type : RACE_DELETE_REQUEST
    }
}

function deleteRaceSuccess(raceNo) {
    return {
        type : RACE_DELETE_SUCCESS,
        payload : raceNo
    }
}

function deleteRaceFailure(error) {
    return {
        type : RACE_DELETE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getRacePigeons(raceNo, clubNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(getRacePigeonsRequest());
        client({
            method: 'GET',
            path: '/api/races/pigeons/' + raceNo + '/' + clubNo
        }).then(response => {
            dispatch(getRacePigeonsSuccess({
                key: raceNo + '/' + clubNo,
                racePigeons: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af foreningsdeltagelse fra databasen", response));
            dispatch(getRacePigeonsFailure(response));
        });
    }
}

function getRacePigeonsRequest() {
    return {
        type : RACE_GET_PIGEONS_REQUEST
    }
}

function getRacePigeonsSuccess(data) {
    return {
        type : RACE_GET_PIGEONS_SUCCESS,
        payload : data
    }
}

function getRacePigeonsFailure(error) {
    return {
        type : RACE_GET_PIGEONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createRacePigeon(race, club, pigeonhole, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createRacePigeonRequest());
        client({
            method: 'POST',
            path: '/api/races/pigeon',
            entity: Object.assign(entity, {
                Foreningsnr: club,
                Slagnr: pigeonhole,
            }),
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createRacePigeonSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                pigeon: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af kapflyvningsdeltager", response));
            dispatch(createRacePigeonFailure(response));
        });
    }
}

function createRacePigeonRequest() {
    return {
        type : RACE_CREATE_PIGEON_REQUEST
    }
}

function createRacePigeonSuccess(data) {
    return {
        type : RACE_CREATE_PIGEON_SUCCESS,
        payload : data
    }
}

function createRacePigeonFailure(error) {
    return {
        type : RACE_CREATE_PIGEON_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updateRacePigeon(race, club, pigeonhole, ring, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateRacePigeonRequest());
        client({
            method: 'PUT',
            path: '/api/races/pigeon/' + race + '/' + ring,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateRacePigeonSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                originalRing: ring,
                pigeon: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af kapflyvningsdeltager", response));
            dispatch(updateRacePigeonFailure(response));
        });
    }
}

function updateRacePigeonRequest() {
    return {
        type : RACE_UPDATE_PIGEON_REQUEST
    }
}

function updateRacePigeonSuccess(data) {
    return {
        type : RACE_UPDATE_PIGEON_SUCCESS,
        payload : data
    }
}

function updateRacePigeonFailure(error) {
    return {
        type : RACE_UPDATE_PIGEON_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deleteRacePigeon(race, club, pigeonhole, ring, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteRacePigeonRequest());
        client({
            method: 'DELETE',
            path: '/api/races/pigeon/' + race + '/' + ring,
        }).then(response => {
            dispatch(deleteRacePigeonSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                ring: ring,
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af kapflyvningsdeltager", response));
            dispatch(deleteRacePigeonFailure(response));
        });
    }
}

function deleteRacePigeonRequest() {
    return {
        type : RACE_DELETE_PIGEON_REQUEST
    }
}

function deleteRacePigeonSuccess(data) {
    return {
        type : RACE_DELETE_PIGEON_SUCCESS,
        payload : data
    }
}

function deleteRacePigeonFailure(error) {
    return {
        type : RACE_DELETE_PIGEON_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createWatch(race, club, pigeonhole, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createWatchRequest());
        client({
            method: 'POST',
            path: '/api/races/watch',
            entity: Object.assign(entity),
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createWatchSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                watch: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af uroplysninger", response));
            dispatch(createWatchFailure(response));
        });
    }
}

function createWatchRequest() {
    return {
        type : RACE_CREATE_WATCH_REQUEST
    }
}

function createWatchSuccess(data) {
    return {
        type : RACE_CREATE_WATCH_SUCCESS,
        payload : data
    }
}

function createWatchFailure(error) {
    return {
        type : RACE_CREATE_WATCH_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updateWatch(race, week, club, pigeonhole, watch, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateWatchRequest());
        client({
            method: 'PUT',
            path: '/api/races/watch/' + week + '/' + club + '/' + pigeonhole + '/' + watch,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateWatchSuccess({
                key: race + '/' + club,
                originalPigeonhole: pigeonhole,
                pigeonhole: isDefined(entity.Slagnr) ? entity.Slagnr : pigeonhole,
                originalWatch: watch,
                watch: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af uroplysninger", response));
            dispatch(updateWatchFailure(response));
        });
    }
}

function updateWatchRequest() {
    return {
        type : RACE_UPDATE_WATCH_REQUEST
    }
}

function updateWatchSuccess(data) {
    return {
        type : RACE_UPDATE_WATCH_SUCCESS,
        payload : data
    }
}

function updateWatchFailure(error) {
    return {
        type : RACE_UPDATE_WATCH_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deleteWatch(race, week, club, pigeonhole, watch, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteWatchRequest());
        client({
            method: 'DELETE',
            path: '/api/races/watch/' + week + '/' + club + '/' + pigeonhole + '/' + watch,
        }).then(response => {
            dispatch(deleteWatchSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                watch: watch,
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af kapflyvningsdeltager", response));
            dispatch(deleteWatchFailure(response));
        });
    }
}

function deleteWatchRequest() {
    return {
        type : RACE_DELETE_WATCH_REQUEST
    }
}

function deleteWatchSuccess(data) {
    return {
        type : RACE_DELETE_WATCH_SUCCESS,
        payload : data
    }
}

function deleteWatchFailure(error) {
    return {
        type : RACE_DELETE_WATCH_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function addMemberGames(race, club, pigeonholes, onSuccess = null) {
    return (dispatch) => {
        dispatch(addMemberGamesRequest());
        client({
            method: 'PUT',
            path: '/api/races/member-games/add/' + race + '/' + club,
            entity: pigeonholes,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(addMemberGamesSuccess({
                key: race + '/' + club,
                pigeonholes: pigeonholes,
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved tilmelding til slagspil", response));
            dispatch(addMemberGamesFailure(response));
        });
    }
}

function addMemberGamesRequest() {
    return {
        type : RACE_ADD_MEMBER_GAMES_REQUEST
    }
}

function addMemberGamesSuccess(data) {
    return {
        type : RACE_ADD_MEMBER_GAMES_SUCCESS,
        payload : data
    }
}

function addMemberGamesFailure(error) {
    return {
        type : RACE_ADD_MEMBER_GAMES_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function removeMemberGames(race, club, pigeonholes, onSuccess = null) {
    return (dispatch) => {
        dispatch(removeMemberGamesRequest());
        client({
            method: 'PUT',
            path: '/api/races/member-games/remove/' + race + '/' + club,
            entity: pigeonholes,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(removeMemberGamesSuccess({
                key: race + '/' + club,
                pigeonholes: pigeonholes,
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved afmelding af slagspil", response));
            dispatch(removeMemberGamesFailure(response));
        });
    }
}

function removeMemberGamesRequest() {
    return {
        type : RACE_REMOVE_MEMBER_GAMES_REQUEST
    }
}

function removeMemberGamesSuccess(data) {
    return {
        type : RACE_REMOVE_MEMBER_GAMES_SUCCESS,
        payload : data
    }
}

function removeMemberGamesFailure(error) {
    return {
        type : RACE_REMOVE_MEMBER_GAMES_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function addDecays(week, race, club, pigeonholes, onSuccess = null) {
    return (dispatch) => {
        dispatch(addDecaysRequest());
        client({
            method: 'PUT',
            path: '/api/races/decays/add/' + week + '/' + club,
            entity: pigeonholes,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(addDecaysSuccess({
                key: race + '/' + club,
                pigeonholes: pigeonholes,
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved registrering af forfald", response));
            dispatch(addDecaysFailure(response));
        });
    }
}

function addDecaysRequest() {
    return {
        type : RACE_ADD_DECAYS_REQUEST
    }
}

function addDecaysSuccess(data) {
    return {
        type : RACE_ADD_DECAYS_SUCCESS,
        payload : data
    }
}

function addDecaysFailure(error) {
    return {
        type : RACE_ADD_DECAYS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function removeDecays(week, race, club, pigeonholes, onSuccess = null) {
    return (dispatch) => {
        dispatch(removeDecaysRequest());
        client({
            method: 'PUT',
            path: '/api/races/decays/remove/' + week + '/' + club,
            entity: pigeonholes,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(removeDecaysSuccess({
                key: race + '/' + club,
                pigeonholes: pigeonholes,
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af forfald", response));
            dispatch(removeDecaysFailure(response));
        });
    }
}

function removeDecaysRequest() {
    return {
        type : RACE_REMOVE_DECAYS_REQUEST
    }
}

function removeDecaysSuccess(data) {
    return {
        type : RACE_REMOVE_DECAYS_SUCCESS,
        payload : data
    }
}

function removeDecaysFailure(error) {
    return {
        type : RACE_REMOVE_DECAYS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getPrices(race, onSuccess = null) {
    return (dispatch) => {
        dispatch(getPricesRequest());
        client({
            method: 'GET',
            path: '/api/races/prices/' + race,
        }).then(response => {
            dispatch(getPricesSuccess({
                race: race,
                prices: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved indlæsning af præmier", response));
            dispatch(getPricesFailure(response));
        });
    }
}

function getPricesRequest() {
    return {
        type : RACE_GET_PRICES_REQUEST
    }
}

function getPricesSuccess(data) {
    return {
        type : RACE_GET_PRICES_SUCCESS,
        payload : data
    }
}

function getPricesFailure(error) {
    return {
        type : RACE_GET_PRICES_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createPrice(priceType, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createPriceRequest());
        client({
            method: 'POST',
            path: '/api/races/price/' + priceType,
            entity: Object.assign(entity),
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createPriceSuccess({
                type: priceType,
                race: entity.Kapflyvningsnr,
                price: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af præmie", response));
            dispatch(createPriceFailure(response));
        });
    }
}

function createPriceRequest() {
    return {
        type : RACE_CREATE_PRICE_REQUEST
    }
}

function createPriceSuccess(data) {
    return {
        type : RACE_CREATE_PRICE_SUCCESS,
        payload : data
    }
}

function createPriceFailure(error) {
    return {
        type : RACE_CREATE_PRICE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updatePrice(priceType, race, section, value, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updatePriceRequest());
        client({
            method: 'PUT',
            path: '/api/races/price/' + priceType + '/' + race + '/' + (section === '' ? 'ddb' : section) + '/' + value,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updatePriceSuccess({
                type: priceType,
                race: race,
                originalSection: section,
                originalValue: value,
                price: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af præmie", response));
            dispatch(updatePriceFailure(response));
        });
    }
}

function updatePriceRequest() {
    return {
        type : RACE_UPDATE_PRICE_REQUEST
    }
}

function updatePriceSuccess(data) {
    return {
        type : RACE_UPDATE_PRICE_SUCCESS,
        payload : data
    }
}

function updatePriceFailure(error) {
    return {
        type : RACE_UPDATE_PRICE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deletePrice(priceType, race, section, value, onSuccess = null) {
    return (dispatch) => {
        dispatch(deletePriceRequest());
        client({
            method: 'DELETE',
            path: '/api/races/price/' + priceType + '/' + race + '/' + (section === '' ? 'ddb' : section) + '/' + value,
        }).then(response => {
            dispatch(deletePriceSuccess({
                type: priceType,
                race: race,
                section: section,
                value: value,
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af præmie", response));
            dispatch(deletePriceFailure(response));
        });
    }
}

function deletePriceRequest() {
    return {
        type : RACE_DELETE_PRICE_REQUEST
    }
}

function deletePriceSuccess(data) {
    return {
        type : RACE_DELETE_PRICE_SUCCESS,
        payload : data
    }
}

function deletePriceFailure(error) {
    return {
        type : RACE_DELETE_PRICE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updatePriceAdditions(priceType, race, additionals, onSuccess = null) {
    return (dispatch) => {
        dispatch(updatePriceAdditionsRequest());
        client({
            method: 'PUT',
            path: '/api/races/price-additions/' + priceType + '/' + race,
            entity: additionals,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updatePriceAdditionsSuccess({
                type: priceType,
                race: race,
                prices: additionals
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af præmietillæg", response));
            dispatch(updatePriceAdditionsFailure(response));
        });
    }
}

function updatePriceAdditionsRequest() {
    return {
        type : RACE_UPDATE_PRICE_ADDITIONS_REQUEST
    }
}

function updatePriceAdditionsSuccess(data) {
    return {
        type : RACE_UPDATE_PRICE_ADDITIONS_SUCCESS,
        payload : data
    }
}

function updatePriceAdditionsFailure(error) {
    return {
        type : RACE_UPDATE_PRICE_ADDITIONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function resetPrices(priceType, race, onSuccess = null) {
    return (dispatch) => {
        dispatch(resetPricesRequest());
        client({
            method: 'GET',
            path: '/api/races/reset-prices/' + priceType + '/' + race,
        }).then(response => {
            dispatch(resetPricesSuccess({
                type: priceType,
                race: race,
                prices: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af præmier", response));
            dispatch(resetPricesFailure(response));
        });
    }
}

function resetPricesRequest() {
    return {
        type : RACE_RESET_PRICES_REQUEST
    }
}

function resetPricesSuccess(data) {
    return {
        type : RACE_RESET_PRICES_SUCCESS,
        payload : data
    }
}

function resetPricesFailure(error) {
    return {
        type : RACE_RESET_PRICES_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function calcPrices(priceType, race, onSuccess = null) {
    return (dispatch) => {
        dispatch(calcPricesRequest());
        client({
            method: 'GET',
            path: '/api/races/calc-prices/' + priceType + '/' + race,
        }).then(response => {
            dispatch(calcPricesSuccess({
                type: priceType,
                race: race,
                prices: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af præmier", response));
            dispatch(calcPricesFailure(response));
        });
    }
}

function calcPricesRequest() {
    return {
        type : RACE_CALC_PRICES_REQUEST
    }
}

function calcPricesSuccess(data) {
    return {
        type : RACE_CALC_PRICES_SUCCESS,
        payload : data
    }
}

function calcPricesFailure(error) {
    return {
        type : RACE_CALC_PRICES_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function calcRaces(races, onSuccess = null) {
    return (dispatch) => {
        dispatch(calcRacesRequest());
        client({
            method: 'POST',
            path: '/api/races/calc-races',
            entity: races,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(calcRacesSuccess(response));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af kapflyvninger", response));
            dispatch(calcRacesFailure(response));
        });
    }
}

function calcRacesRequest() {
    return {
        type : RACE_CALC_REQUEST
    }
}

function calcRacesSuccess(data) {
    return {
        type : RACE_CALC_SUCCESS,
        payload : data
    }
}

function calcRacesFailure(error) {
    return {
        type : RACE_CALC_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getBasics(onSuccess = null) {
    return (dispatch) => {
        dispatch(getBasicsRequest());
        client({
            method: 'GET',
            path: '/api/races/basics',
        }).then(response => {
            dispatch(getBasicsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved indlæsning af grunddata", response));
            dispatch(getBasicsFailure(response));
        });
    }
}

function getBasicsRequest() {
    return {
        type : RACE_GET_BASICS_REQUEST
    }
}

function getBasicsSuccess(data) {
    return {
        type : RACE_GET_BASICS_SUCCESS,
        payload : data
    }
}

function getBasicsFailure(error) {
    return {
        type : RACE_GET_BASICS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function startDeviceImport(id, input, onSuccess = null) {
    return (dispatch) => {
        dispatch(startDeviceImportRequest({
            id: id,
            input: input,
        }));
        client({
            method: 'POST',
            path: '/api/device-import/' + id,
            entity: input,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(startDeviceImportSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved start af import", response));
            dispatch(startDeviceImportFailure(response));
        });
    }
}

function startDeviceImportRequest(data) {
    return {
        type : RACE_START_DEVICE_IMPORT_REQUEST,
        payload : data
    }
}

function startDeviceImportSuccess(data) {
    return {
        type : RACE_START_DEVICE_IMPORT_SUCCESS,
        payload : data
    }
}

function startDeviceImportFailure(error) {
    return {
        type : RACE_START_DEVICE_IMPORT_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updateDeviceImport(id, input, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateDeviceImportRequest());
        client({
            method: 'PUT',
            path: '/api/device-import/' + id,
            entity: input,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateDeviceImportSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved start af import", response));
            dispatch(updateDeviceImportFailure(response));
        });
    }
}

function updateDeviceImportRequest() {
    return {
        type : RACE_UPDATE_DEVICE_IMPORT_REQUEST
    }
}

function updateDeviceImportSuccess(data) {
    return {
        type : RACE_UPDATE_DEVICE_IMPORT_SUCCESS,
        payload : data
    }
}

function updateDeviceImportFailure(error) {
    return {
        type : RACE_UPDATE_DEVICE_IMPORT_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function checkDeviceImport(id, onSuccess = null) {
    return (dispatch) => {
        dispatch(checkDeviceImportRequest());
        client({
            method: 'GET',
            path: '/api/device-import/' + id,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            response.id = id;
            dispatch(checkDeviceImportSuccess(response.entity));
            if (response.entity.requestType === "signups" || response.entity.requestType === "results") {
                if (response.entity.info === "success") {
                    const msg = ["Indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + (response.entity.reference !== null ? " for " + response.entity.reference : "") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + " er gennemført."];
                    const messages = response.entity.messages.split('|');
                    if (messages.length > 0) msg.push('');
                    alert("Info", msg.concat(messages).map((line, ix) => [line, <br/>]), () => {}, {textAlign: "left"});
                    //NotificationManager.success("Indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + (response.entity.reference !== null ? " for " + response.entity.reference : "") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + " er gennemført.", "Indlæsning", 4000);
                }
                if (response.entity.info === "timed out") NotificationManager.warning("Indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + " er udløbet.", "Timeout", 4000);
                //if (response.entity.info === "error") NotificationManager.error("Fejl ved indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + (response.entity.data !== null ? ": " + response.entity.data : "") + ".", "Fejl", 4000);
                if (response.entity.info === "error") alert("Fejl", <span>{"Fejl ved indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + (response.entity.data !== null ? ": " + response.entity.data : "") + "."}</span>, () => {});
            }
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af import", response));
            dispatch(checkDeviceImportFailure(response, id));
        });
    }
}

function checkDeviceImportRequest() {
    return {
        type : RACE_CHECK_DEVICE_IMPORT_REQUEST
    }
}

function checkDeviceImportSuccess(data) {
    return {
        type : RACE_CHECK_DEVICE_IMPORT_SUCCESS,
        payload : data
    }
}

function checkDeviceImportFailure(error, id) {
    return {
        type : RACE_CHECK_DEVICE_IMPORT_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity,
            id: id
        }
    }
}


export function sendFromClub(type, input, onSuccess = null) {
    return (dispatch) => {
        dispatch(sendFromClubRequest());
        client({
            method: 'PUT',
            path: type === 'signup' ? '/api/export/send-signups' : '/api/export/send-results',
            entity: input,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(sendFromClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            if (response.entity.userMessage.includes('\r\n')) {
                //const msg = response.entity.userMessage.split('\r\n').map((line, ix) => <div key={"msgline" + ix}>{line}</div>);
                const msg = response.entity.userMessage.split('\r\n').map((line, ix) => [line, <br/>]);
                alert("Fejl", msg, () => {}, {textAlign: "left"});
            } else dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl", response));
            dispatch(sendFromClubFailure(response));
        });
    }
}

function sendFromClubRequest() {
    return {
        type : RACE_SEND_FROM_CLUB_REQUEST
    }
}

function sendFromClubSuccess(data) {
    return {
        type : RACE_SEND_FROM_CLUB_SUCCESS,
        payload : data
    }
}

function sendFromClubFailure(error) {
    return {
        type : RACE_SEND_FROM_CLUB_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getFromMember(club, week, pigeonHole, reset, overwrite, onSuccess = null) {
    return (dispatch) => {
        dispatch(getFromMemberRequest());
        client({
            method: 'GET',
            path: '/api/import/get-signups/' + club + '/' + week + '/' + pigeonHole + '/' + (reset ? 'reset' : overwrite ? 'overwrite' : 'keep'),
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(getFromMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning fra medlemsprogrammet", response));
            dispatch(getFromMemberFailure(response));
        });
    }
}

function getFromMemberRequest() {
    return {
        type : RACE_GET_FROM_MEMBER_REQUEST
    }
}

function getFromMemberSuccess(data) {
    return {
        type : RACE_GET_FROM_MEMBER_SUCCESS,
        payload : data
    }
}

function getFromMemberFailure(error) {
    return {
        type : RACE_GET_FROM_MEMBER_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


// WEBPACK FOOTER //
// ./src/client/src/actions/race.js